var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "black",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 17.9847V18H8.61127L12.5 13.4625L16.3732 18H18V17.9847L13.3056 12.5L13.3138 12.4904L12.5005 11.5369L12.5 11.5375L8.61127 7H7V7.01528L11.6789 12.5L7 17.9847Z",
    fill: "black",
    fillOpacity: 0.38
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.32 10.5769L14.1349 11.5279L17.9845 7.01528V7H16.3732L13.32 10.5769Z",
    fill: "black",
    fillOpacity: 0.38
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.fbf74a25bd756ab977273167cbcdbbed.svg";
export { ForwardRef as ReactComponent };